import { Directive, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[highlightIfHasValue]',
  standalone: false,
})
export class HighlightIfHasValueDirective {
  constructor(
    private el: ElementRef,
    private ngControl: NgControl
  ) {}

  ngDoCheck() {
    const value = this.ngControl.control?.value;
    const hasValue = value !== null && value !== undefined && value !== '';

    const classes = ['border', 'border-3', 'border-primary', 'rounded-3'];
    classes.forEach((cls) => this.el.nativeElement.classList.toggle(cls, hasValue));
  }
}
